
import { mapState, mapMutations, mapActions } from 'vuex'
import Paging from '~/components/Theme/ThemePaging'

import api from '~/api/'
export default {
    name: 'StockNameChanged',
    components: {
        Paging,
    },
    data() {
        return {
            listData: [],
            totalCount: 0,
            curPage: 1,
            countByPage: 15,
            params: null,
            idxReset: [], 
        }
    },
    computed: {
        setTotalCount() {
            let count = 0
            if (this.listData) {
                count = this.totalCount
            }
            // console.log('count', count)
            return count
        },

    },
    watch: {
        listData() {
            this.forceRerender()
        },
    },
    created() {
        this.params = { pageNo: this.curPage, countByPage: this.countByPage }
        this.getListData(this.params)
    },

    methods: {
        onClickPage(page) {
            this.curPage = page
            this.params.pageNo = page
            this.getListData(this.params)
            this.resetSelectedRow()
        },

        async getListData(params) {
            
            const res = await api.getStockNameChanged(params) 
            this.listData = res.data.items 
            this.totalCount = res.data.totalCount

            // 정렬 기준 eventDate
            // this.listData.items.sort((a,b) => b.eventDate - a.eventDate)      
        },

        // stocks=종목코드:종목명 -> 종목코드 뽑기 함수 
        stockCodeOnly(stocks){
            if(stocks !== null){
                let splited
                if(stocks.includes(':')){
                    splited = stocks.split(':')
                    splited = splited[0]
                } else {
                    splited = stocks
                }
                return splited 
            }
        },

        // content 줄바꿈 함수 
        addEnter(content){ 
            if(content.includes('\r\n\r\n')){
                const array = content.split('\r\n\r\n')   
                return array 
            } else if(content.includes('\n\n')){
                const array = content.split('\n\n')   
                return array 
            } else {
                return content
            }
        },
     
        onClickitem(id) {
            const el = document.getElementById(id)
            if (el.style.display === 'table-row') {
                el.style.display = 'none'
            } else {
                el.style.display = 'table-row'
            }

            this.idxReset.push(id)
        },

        // 선택row 초기화 함수
        resetSelectedRow(){
            if(this.idxReset !== null){
                this.idxReset.forEach(e => {
                const el = document.getElementById(e)
                el.style.display = 'none'
            });
            }   
        },

        forceRerender() {
            this.componentKey += 1
        },
     
    },
}
